<template>
    <div class="w-full h-full">
        <h2 class="text-xl font-semibold">Related Teaching Resources</h2>

        <AisInstantSearch :searchClient="client" :indexName="indexName">
            <AisConfigure :hitsPerPage.sync="4" :page="0" :filters="filters"></AisConfigure>
            <AisHits>
                <template #default="{ items }">
                    <div class="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-4 w-full mt-6">
                        <template v-for="resource in items" :key="resource?.id">
                            <ResourceItem v-if="resource.is_external_resource" :resource="resource"
                            :isBookmarked="bookmarkedResourcesIds.includes(resource.id)"
                            @bookmarkUpdated="bookmarkUpdated" />
                            <InternalResourceItem v-else :material="resource"
                                :isBookmarked="bookmarkedResourcesIds.includes(resource.id)"
                            @bookmarkUpdated="bookmarkUpdated"  />
                        </template>

                    </div>
                </template>
            </AisHits>
        </AisInstantSearch>

    </div>
</template>

<script>
import { AisInstantSearch, AisHits, AisConfigure } from 'vue-instantsearch/vue3/es';
import { instantMeiliSearch } from '@meilisearch/instant-meilisearch';
import { getMeilisearchUserId } from '../../../Helpers/MeilisearchAnalytics.js';
import { trackMeilisearchRequest } from '../../../Helpers/MeilisearchRequestTracker.js';
import { usePage } from '@inertiajs/vue3'

import ResourceItem from '../../Resources/components/ResourceItem.vue';

import InternalResourceItem from '../../StcMaterials/components/MaterialItem.vue'



export default {
    components: {
        ResourceItem,
        InternalResourceItem,
        AisConfigure,
        AisInstantSearch,
        AisHits,

    },
    props: {
        resource: Object,
        bookmarkedResourcesIds: {
            type: Array,
            default: []
        }
    },
    computed: {
        indexName() {
            return usePage().props.integrations?.meilisearch?.teachingMaterialsIndex || usePage().props.integrations?.algolia?.teachingMaterialsIndex || 'teaching_materials';
        },
        filters() {
            let filter = `is_live=true AND id!=${this.resource.id}`;
            
            // Use IN operator for Meilisearch array filtering
            if(this.resource.keywords && this.resource.keywords.length > 0) {
                const keywordsList = this.resource.keywords.map(keyword => `'${keyword.replace(/'/g, "''")}'`).join(', ');
                filter += ` AND keywords IN [${keywordsList}]`;
            }
            
            if(this.resource.grades && this.resource.grades.length > 0) {
                // Handle both string and object grades
                const gradeValues = this.resource.grades.map(grade => {
                    const gradeValue = typeof grade === 'object' ? grade.name || grade : grade;
                    return `'${String(gradeValue).replace(/'/g, "''")}'`;
                }).join(', ');
                filter += ` AND grades IN [${gradeValues}]`;
            }
            
            return filter;
        }
    },
    setup() {
        let meilisearchHost = usePage().props.integrations?.meilisearch?.host || (typeof window !== 'undefined' ? window.MEILISEARCH_HOST : undefined) || 'http://localhost:7700';
        let meilisearchKey = usePage().props.integrations?.meilisearch?.key || (typeof window !== 'undefined' ? window.MEILISEARCH_KEY : undefined) || '';
        const userId = getMeilisearchUserId();
        
        const client = instantMeiliSearch(meilisearchHost, meilisearchKey, {
            placeholderSearch: false,
            primaryKey: 'id',
            requestConfig: {
                headers: {
                    'X-MS-USER-ID': userId,
                },
            },
        }).searchClient;
        return { client }
    },
    mounted() {
        trackMeilisearchRequest({
            tenantId: usePage().props.tenantId,
            index: this.indexName,
            source: 'related',
        });
    },
    methods: {
        bookmarkUpdated({ id, is_bookmarked }) {
            let index = this.bookmarkedResourcesIds.indexOf(id);
            if (is_bookmarked && index == - 1)
                this.bookmarkedResourcesIds.push(id);

            else if (!is_bookmarked && index > -1)
                this.bookmarkedResourcesIds.splice(index, 1)
        }
    }
}
</script>
